"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var helpers_exports = {};
__export(helpers_exports, {
  objectEntries: () => objectEntries,
  objectFromEntries: () => objectFromEntries,
  objectKeys: () => objectKeys
});
module.exports = __toCommonJS(helpers_exports);
var objectKeys = function(obj) {
  return Object.keys(obj);
};
function objectEntries(obj) {
  return Object.entries(obj);
}
function objectFromEntries(arr) {
  return Object.fromEntries(arr);
}
//# sourceMappingURL=helpers.js.map
